import type { TAudioActionId } from '../types/audioActionTypes'

/** Display order of the owner's more-actions list (audio-web `MORE_ACTIONS`). */
export const OWNER_MORE_ACTIONS: readonly TAudioActionId[] = [
    'replace-source',
    'add-to-collection',
    'download',
    'delete',
] as const
